import { TaxListPage } from '@/features/tax/pages/TaxListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/tax/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["tax.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TaxListPage,
})
